<template>
  <div>
    <text-des
      v-for="(item, index) in list"
      :value="item"
      :key="item.id"
      :title="titleList[index].title"
      @changeText="changeText"
    >
      <span slot="title">
        <span class="titlemenu">{{ item.title }}</span></span
      >
      <span slot="append">{{ item.appendTitle }}</span>
    </text-des>
    <Confirm @savePage="saveData" />
    <!-- <div v-for="(item, index) in list" :key="item.title">
      <div class="mt-4">
        <span class="titlemenu mt-4">{{ item.title }}</span
        ><span class="title-append"></span>
      </div>

      <div class="classManger">
        <rich-text
          :id="'id' + index + 2"
          :ids="index + 2"
          :value="item"
        ></rich-text>
      </div>
    </div> -->
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";
/* 考试报名 */
import ue2 from "@/components/common/UE2.vue";
import RichText from "../components/RichText.vue";
import TextDes from "../components/TextDes.vue";
import Confirm from "../components/Confirm.vue";
import commonMixin from "../mixin/index.js";
export default {
  components: { ue2, RichText, TextDes, Confirm },
  mixins: [commonMixin],
  props: {
    /*  value: {
      type: Object,
      default: {},
    }, */
    com: {
      tyoe: String,
      default: "",
    },
  },
  data() {
    return {
      titleList: [
        { title: "证书领取方式", appendTitle: "" },
        {
          title: "证书样式",
          appendTitle: "",
        },
      ],
      list: [
        /*  { id: 1, value: 1, title: "报名条件", appendTitle: "" },
        {
          id: 2,
          value: 3,
          title: "报名时间",
          appendTitle: "通过这门考试的科目，科目可以拖动排序",
        },
        {
          id: 3,
          value: 3,
          title: "报名流程",
          appendTitle: "报名流程尽可能用图表示，每一步如何操作",
        }, */
      ],
    };
  },
  methods: {
    /* changeText(obj) {
      
      const index = this.list.findIndex((item) => item.title === obj.title);
      if (index >= 0) {
        this.$set(this.list, index, obj);
        
      }
      console.warn("未找到符合项");
    
    },
    savePage() {
      this.$emit("change", {
        type: this.com,
        subjectGuideItemDetails: [...this.list],
      });
      console.log("点击了包存");
    }, */
  },
  watch: {
    value: {
      handler(val) {
        //  debugger;
        //console.log("传值改变了", val);
        const list = val.subjectGuideItemDetails || [];
        this.list = list;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    /*  this.getCampusList();
    this.getPageList(); */
  },
  mounted() {
    /* window.onresize = () => {
      this.setaddDialogwidth();
    }; */
  },
};
</script>
<style scoped>
.myfade-enter-active,
.myfade-leave-active {
  transition: all 0.2s ease-out;
}
/* 进场的瞬间与离场的效果添加 */
.myfade-enter,
.myfade-leave-to {
  opacity: 0;
  transform: translateX(200px);
}
.titlemenu {
  font-weight: 600;
  font-size: 16px;
}
.title-append {
  margin-left: 1rem;
  color: #a5a5a5;
}
.mt-4 {
  margin-top: 1rem;
}
.i-icon {
  font-size: 16px;
  display: inline-block;
  color: #66b1ff;
  cursor: pointer;
}
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/addGuide/module/certificateToReceive.vue